export default "__VITE_ASSET__BQ0Y3_TG__"